import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    customerId: null,
    customerName: '',
    rawTo: null,
    dateTo: null,
  },
  list: [],
  loading: false,
  selectedCustomer: null,
  searchResults: [],
  loadingSearch: false,
};

const emiDueSlice = createSlice({
  name: 'emiDue',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setEmiDueData: (state, action) => {
      state.list = action.payload.list || [];
      state.selectedCustomer = action.payload.customer || null;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingSearch: (state, action) => {
      state.loadingSearch = action.payload;
    },
    resetState: () => initialState,
  },
});

export const { setFilters, setEmiDueData, setSearchResults, setLoading, setLoadingSearch, resetState } = emiDueSlice.actions;
export default emiDueSlice.reducer;